import { isEmptyArray } from '@vy/utils';
import { useMemo, useState } from 'react';
import { DEBOUNCE_DELAY } from '../components/design/Input/input-consts';
import type { FormattedIntegrationProduct } from '../utils/types/formatted-integration-product';
import { useXeroProducts } from './requests/integrations';
import { useDebounce } from './use-debounce';

export function useFormattedXeroProducts() {
  const [searchInput, setSearchInput] = useState<string | undefined>(undefined);
  const debouncedSearchValue = useDebounce(searchInput, DEBOUNCE_DELAY);
  const { data: { products } = {}, isLoading } = useXeroProducts(debouncedSearchValue, {
    keepPreviousData: true,
    suspense: false,
  });

  const formattedProducts = useMemo((): FormattedIntegrationProduct[] => {
    if (isEmptyArray(products)) {
      return [];
    }

    return products.map(({ id, name }) => ({ id, name }));
  }, [products]);

  return {
    products: formattedProducts,
    isLoading,
    setSearchInput,
  };
}
